import React from 'react';
import I18n from 'i18n-js';
import { Lesson, Program, SectionType } from '@/types/api/LessonOverview';
import LessonSubheader from '@/components/shared/LessonOverview/LessonSubheader';
import { AssessmentsCard, LessonGameCard, NotebookCards } from './Cards';

interface AssessWithProps {
  hasAssessments?: boolean;
  lesson: Lesson;
  program: Program;
  sections: SectionType[]
  stafferId?: number;
}

const AssessWith = ({ hasAssessments, lesson, program, sections, stafferId }: AssessWithProps) => (
  <LessonSubheader
    title={I18n.t('assess_with')}
    description={I18n.t('lesson_subheader_assess_with')}
    isStaffer={!!stafferId}
  >
    <NotebookCards
      lesson={lesson}
      program={program}
      sections={sections}
      stafferId={stafferId}
    />

    {lesson.lessonGameAssignables?.length > 0 && (
      <LessonGameCard
        bannerBorderColor="orange"
        lesson={lesson}
        lessonId={lesson.id}
        program={program}
        stafferId={stafferId}
        type="lesson-game"
      />
    )}

    {(hasAssessments || stafferId) && (
      <AssessmentsCard
        bannerBorderColor="orange"
        hasAssessments={hasAssessments}
        lesson={lesson}
        lessonId={lesson.id}
        program={program}
        stafferId={stafferId}
        type="assessments"
      />
    )}
  </LessonSubheader>
);

export default AssessWith;
